// Same-origin proxy: SWA Function in production, CRA proxy in local development.
import axios from 'axios';
import { createAppTransport } from '@1823-partners/core';

const api = createAppTransport({ axios, appName: 'secmaster' });

// `before`: the UTC instant from utils/asOf (the start of the day after the
// picked local date); the backend compares stored UTC instants against it.
// `modified_date` is the old date-only form, sent only so a backend without
// `before` support keeps answering; one that has it ignores the date.
export const fetchSecMaster = async (before, localDay) => {
  const params = new URLSearchParams({ before });
  if (localDay) params.append('modified_date', localDay);
  return api.get(`/secmaster-entries?${params.toString()}`);
};

export const fetchSecMasterEntry = async (cusip_ppn) => {
  return api.get(`/secmaster-entry?cusip_ppn=${encodeURIComponent(cusip_ppn)}`);
};

export const saveSecMaster = async (secMaster) => {
  return api.post('/save-secmaster', secMaster);
};

export const deleteSecMaster = async (secMaster) => {
  return api.post('/delete-entry', secMaster);
};

export const addUserAction = async (email, cusips, action) => {
  return api.post('/add-user-action', {
    email,
    cusips,
    action,
  });
};

export const fetchRatingsInputs = () => api.get('/ratings-inputs');
export const saveRatingsInputs = (records) => api.post('/save-ratings-inputs', records);

export const fetchRatings = (asofdt) =>
  api.get(asofdt ? `/ratings-entries?asofdt=${encodeURIComponent(asofdt)}` : '/ratings-entries');
export const saveRatings = (records) => api.post('/save-ratings', records);
export const fetchRatingsDetail = (cusip) =>
  api.get(`/ratings-detail?cusip=${encodeURIComponent(cusip)}`);
export const fetchRatingsHistory = (cusip) =>
  api.get(`/ratings-history?cusip=${encodeURIComponent(cusip)}`);

export default api;
